import React from 'react'
import { compose } from 'recompose'
import { connect, ConnectedProps } from 'react-redux'
import { push } from 'connected-react-router'
import { BTitle, BSpinner, BText } from '@prague-digi/ui-components'

import messages from '../../i18n'
import { intl, wizard, WizardInterface, IntlInterface, errorHandler } from '../../hoc'
import { analyticsActions, modalDialogActions, scoringActions } from '../../redux'
import Routes from '../../constants/routes'
import { TECHNICAL_DIFFICULTIES } from '../../constants/errorModals'
import { CLIENT_SCORING_ERRORS } from '../../constants/errors'
import { API_ERROR } from '../../constants/modals'
import { Response } from '../../api/api'

import styles from './styles.scss'

type Props = IntlInterface & WizardInterface & ConnectedProps<typeof connector>

interface State {
  text: any
}

export class ClientScoring extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      text: props.translateHTML(messages.ClientScoring.text),
    }
  }

  componentDidMount(): void {
    this.doClientScoring(false)
  }

  doClientScoring = (skipCreate: boolean) => {
    const scoringSagaParams = {
      success: () => {
        this.props.wizard.gotoNext()
      },
      error: (errorType: string, reason: string) => {
        if (errorType === CLIENT_SCORING_ERRORS.NOK) {
          this.props.setScoringReason(reason)
          this.props.setDenialReason(reason || '')
          this.props.setAnalyticsPage(Routes.KO_SCORING)
          this.props.push(Routes.KO_SCORING)
        } else if (errorType === CLIENT_SCORING_ERRORS.TIMEOUTED) {
          this.props.setScoringReason('TIMEOUT')
          this.props.setAnalyticsPage(Routes.KO_SCORING)
          this.props.push(Routes.KO_SCORING)
        } else {
          this.props.showModalDialog(TECHNICAL_DIFFICULTIES)
        }
      },
      apiError: (errorType: Response, skipCreate: boolean) => {
        this.props.showModalDialog(
          API_ERROR({
            errorInfo: { type: errorType },
            onRetry: () => this.doClientScoring(skipCreate),
          })
        )
      },
      updateText: (text: string) => {
        this.setState({
          text,
        })
      },
    }

    if (skipCreate) {
      this.props.startScoringLoop(scoringSagaParams)
    } else {
      this.props.startScoring(scoringSagaParams)
    }
  }

  render() {
    return (
      <div>
        <BTitle type="h3" center>
          {this.props.translateHTML(messages.ClientScoring.title)}
        </BTitle>
        <BText center>{this.state.text}</BText>
        <BSpinner isStatic isShown theme={styles.spinner} />
      </div>
    )
  }
}

const connector = connect(null, {
  setAnalyticsPage: analyticsActions.setAnalyticsPage,
  setDenialReason: scoringActions.setDenialReason,
  setScoringReason: analyticsActions.setScoringReason,
  showModalDialog: modalDialogActions.showModalDialog,
  startScoring: scoringActions.startScoring,
  startScoringLoop: scoringActions.startScoringLoop,
  push,
})

export default compose(
  errorHandler('containers/ClientScoring/ClientScoring.tsx'),
  wizard,
  connector,
  intl
)(ClientScoring)
